import axios from "axios";
import { API_URL } from "../constants/api";
import { trackAPIError } from "../utils/mixpanel";

const instance = axios.create({
  baseURL: API_URL,
});

// Response interceptor for API error tracking
instance.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Track API errors in Mixpanel
    const { config, response } = error;

    if (config && response) {
      trackAPIError({
        endpoint: config.url || "",
        method: (config.method || "GET").toUpperCase(),
        status_code: response.status || 0,
        error_message:
          response.data?.message || response.statusText || "Unknown error",
      });
    } else if (config) {
      // Network error (no response)
      trackAPIError({
        endpoint: config.url || "",
        method: (config.method || "GET").toUpperCase(),
        status_code: 0,
        error_message: error.message || "Network error",
      });
    }

    // Re-throw the error so it can be handled by the calling code
    return Promise.reject(error);
  },
);

export default instance;
